//import './App.css';
import { BrowserRouter, Routes, Route, Link} from "react-router-dom";

import Layout from './pages/Layout';
//import Home from './pages/home/Home';
import Profile from './pages/profile/Profile';
import EVPV from './pages/e-v-p-v/E_v_p_v';
import HUOZE from "./pages/h-u-OZE/H_u_OZE";
import TabulkyAPomocky from "./pages/tabulky-a-pomocky/TabulkyAPomocky";
import SvkNaFchaptStuba from "./pages/svk-na-fchapt-stuba/SvkNaFchaptStuba";
import Termomechanika from "./pages/termomechanika/Termomechanika";
import PouzitiePlastov from "./pages/pouzitie-plastov/PouzitiePlastov";
import PouzitiePlynov from "./pages/pouzitie-plynov/PouzitiePlynov";
import DopravaDPI from "./pages/doprava-d-p-I/Doprava_d_p_I";
import DopravaDPII from "./pages/doprava-d-p-II/Doprava_d_p_II";
import EnergetickeStroje from "./pages/energeticke-stroje/EnergetickeStroje";
import BezpecnostVPlynarenstve from "./pages/bezpecnost-v-plynarenstve/BezpecnostVPlynarenstve";
import PlynSysAPoPlynov from "./pages/plyn-sys-a-po-plynov/Plyn_sys_a_po_plynov";
import ZakladyProgramovania from "./pages/zaklady-programovania/ZakladyProgramovania";
import PrenosTepla from "./pages/prenos-tepla/PrenosTepla";
import UcinnostProcesnychZariadeni from "./pages/ucinnost-procesnych-zariadeni/UcinnostProcesnychZariadeni";
import VzduchotechnickeZariadenia from "./pages/vzduchotechnicke-zariadenia/VzduchotechnickeZariadenia";
import SpalovacieProcesy from "./pages/spalovacie-procesy/SpalovacieProcesy";
import HydroATermomechanika from "./pages/hydro-a-termomechanika/HydroATermomechanika";
import TepelneProcesy from "./pages/tepelne-procesy/TepelneProcesy";
import HodFyzFaktorovPracProstredia from "./pages/hod-fyz-faktotorov-prac-prostredia/Hod_fyz_faktorov_prac_prostredia";
import MetRiesPrenTeplaVEnProces from "./pages/met-ries-pren-tepla-v-en-proces/MetRiesPrenTeplaVEnProces";
import EnergetickeStrojeAZariadenia from "./pages/energeticke-stroje-a-zariadenia/EnergetickeStrojeAZariadenia";
import AplikSoftverVEI from "./pages/aplik-softver-v-e-i/AplikSoftverVEI";
import AplikSoftverVEIi from "./pages/aplik-softver-v-e-ii/AplikSoftverVEIi";
import AplikSoftverVTTI from "./pages/aplik-softver-v-TT-i/AplikSoftverVTTI";
import AplikSoftverVTTIi from "./pages/aplik-softver-v-TT-ii/AplikSoftverVTTIi";
import DopravaADisPlynov from "./pages/doprava-a-dis-plynov/DopravaADisPlynov";
import PrevadzkaAUdrPlynZar from "./pages/prevadzka-a-udr-plyn-zar/PrevadzkaAUdrPlynZar";
import PlynarenskeTechnologie from "./pages/plynarenske-technologie/PlynarenskeTechnologie";
import SoftverVTepTechnike from "./pages/softver-v-tep-technike/SoftverVTepTechnike";
import TechnikaProstredia from "./pages/technika-prostredia/TechnikaProstredia";
import OdporucanySoftver from "./pages/odporucany-softver/OdporucanySoftver";

import NoPage from "./pages/NoPage";
import { Container, Row, Col, ListGroup, NavDropdown } from 'react-bootstrap';

import LinkBar from "./appComponents/LinkBar";
import RightSidePage from "./appComponents/RightSidePage";



function App() {


  return (
    <div className="App">

      <LinkBar/>

      
{/*
     <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home/>} />
            <Route path="profile" element={<Profile/>}/>
            <Route path="*" element={<NoPage/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
 */}
  <BrowserRouter>
      <Container fluid>
        <Row>
          
          <Col xs={12} md={3} className="bg-light p-3 sidebar" >
            <h4>Menu</h4>
            <ListGroup defaultActiveKey="/" >
              <ListGroup.Item action as={Link} to="/" className="text-primary">
                Profil
              </ListGroup.Item>
              <ListGroup.Item action as={Link} to="/tabulka_a_pomocky" className="text-primary">
                Tabuľky a pomôcky
              </ListGroup.Item>
              <ListGroup.Item action as={Link} to="/svk_na_fchapt_stuba" className="text-primary">
                SVK na FCHaPT STUBA
              </ListGroup.Item>

              <ListGroup.Item>
                <NavDropdown title="Pedagogika" id="basic-nav-dropdown" className="text-primary">
                  <NavDropdown title="FVT, TUKE" id="basic-nav-dropdown" className="text-primary">
                    <NavDropdown.Item action as={Link} to="/hodnotenie_ucinnosti_OZE" className="text-primary">Hodnotenie účinnosti OZE</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/prenosy_tepla" className="text-primary">Prenosy tepla</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/ucinnost_procesnych_zariadeni" className="text-primary">Účinnosť procesných zariadení</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/vzduchotechnicke_zariadenia" className="text-primary">Vzduchotechnické zariadenia</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/spalovacie_procesy" className="text-primary">Spaľovacie procesy</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/hydro_a_termomechanika" className="text-primary">Hydro a Termomechanika</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/tepelne_procesy" className="text-primary">Tepelné procesy</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/energetika_v_priemyselnych_vyrobach" className="text-primary">Energetika v priemyselných výrobách</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/energeticke_stroje_a_zariadenia" className="text-primary">Energetické stroje a zariadenia</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/hodnotenie_fyzikalnych_faktorov_pracovneho_prostredia" className="text-primary">Hodnotenie fyzikálnych faktorov pracovného prostredia</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/metody_riesenia_prenosu_tepla_v_energetickych_procesoch" className="text-primary">Metódy riešenia prenosu tepla v energetických procesoch</NavDropdown.Item>
                  </NavDropdown>
                    <NavDropdown title="HF/FMMR, TUKE" id="basic-nav-dropdown" className="text-primary">
                    <NavDropdown.Item action as={Link} to="/aplikovany_softver_v_e_i" className="text-primary">Aplikovaný softvér v E I</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/aplikovany_softver_v_e_ii" className="text-primary">Aplikovaný softvér v E II</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/aplikovany_softver_v_tt_i" className="text-primary">Aplikovaný softvér v TT I</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/aplikovany_softver_v_tt_ii" className="text-primary">Aplikovaný softvér v TT II</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/bezpecnost_v_plynarenstve" className="text-primary">Bezpečnosť v plynárenstve</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/doprava_a_distribucia_plynov" className="text-primary">Doprava a distribúcia plynov</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/energeticke_stroje" className="text-primary">Energetické stroje</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/pouzitie_plastov" className="text-primary">Použitie plastov</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/pouzitie_plynov" className="text-primary">Použitie plynov</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/plynarske_systemy_a_pouzitie_plynov" className="text-primary">Plynárenské systémy a použitie plynov</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/prevadzka_a_udrzba_plynarenskych_zariadeni" className="text-primary">Prevádzka a údržba plynárenských zariadení</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/plynarenske_technologie" className="text-primary">Plynárenské technológie</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/softver_v_tepelnej_technike" className="text-primary">Softvér v Tepelnej technike</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/technika_prostredia" className="text-primary">Technika prostredia</NavDropdown.Item>
                    <NavDropdown.Item action as={Link} to="/termomechanika" className="text-primary">Termomechanika</NavDropdown.Item>
                  </NavDropdown>
                </NavDropdown>
              </ListGroup.Item>

              <ListGroup.Item action as={Link} to="/odporucany_softver" className="text-primary">
                Odporúčaný softvér
              </ListGroup.Item>
            </ListGroup>
          </Col>

          <Col xs={12} md={6} className="content p-3">
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Profile />} />
                <Route path="profile" element={<Profile />} />
                <Route path="energetika_v_priemyselnych_vyrobach" element={<EVPV />} />
                <Route path="hodnotenie_ucinnosti_OZE" element={< HUOZE/>} />
                <Route path="tabulka_a_pomocky" element={< TabulkyAPomocky/>} />
                <Route path="svk_na_fchapt_stuba" element={< SvkNaFchaptStuba/>} />
                <Route path="termomechanika" element={< Termomechanika/>} />
                <Route path="pouzitie_plastov" element={<PouzitiePlastov/>} />
                <Route path="pouzitie_plynov" element={< PouzitiePlynov/>} />
                <Route path="doprava_a_distribucia_plynov_1" element={< DopravaDPI/>} />
                <Route path="doprava_a_distribucia_plynov_2" element={< DopravaDPII/>} />
                <Route path="energeticke_stroje" element={< EnergetickeStroje/>} />
                <Route path="bezpecnost_v_plynarenstve" element={<BezpecnostVPlynarenstve />} />
                <Route path="plynarske_systemy_a_pouzitie_plynov" element={<PlynSysAPoPlynov />} />
                <Route path="zaklady_programovania" element={<ZakladyProgramovania />} />
                <Route path="prenosy_tepla" element={<PrenosTepla />} />
                <Route path="ucinnost_procesnych_zariadeni" element={<UcinnostProcesnychZariadeni />} />
                <Route path="vzduchotechnicke_zariadenia" element={<VzduchotechnickeZariadenia />} />
                <Route path="spalovacie_procesy" element={<SpalovacieProcesy />} />
                <Route path="hydro_a_termomechanika" element={<HydroATermomechanika />} />
                <Route path="tepelne_procesy" element={<TepelneProcesy />} />
                <Route path="hodnotenie_fyzikalnych_faktorov_pracovneho_prostredia" element={<HodFyzFaktorovPracProstredia />} />
                <Route path="metody_riesenia_prenosu_tepla_v_energetickych_procesoch" element={<MetRiesPrenTeplaVEnProces />} />
                <Route path="energeticke_stroje_a_zariadenia" element={<EnergetickeStrojeAZariadenia />} />
                <Route path="aplikovany_softver_v_e_i" element={<AplikSoftverVEI />} />
                <Route path="aplikovany_softver_v_e_ii" element={<AplikSoftverVEIi />} />
                <Route path="aplikovany_softver_v_tt_i" element={<AplikSoftverVTTI />} />
                <Route path="aplikovany_softver_v_tt_ii" element={<AplikSoftverVTTIi />} />
                <Route path="doprava_a_distribucia_plynov" element={<DopravaADisPlynov />} />
                <Route path="prevadzka_a_udrzba_plynarenskych_zariadeni" element={<PrevadzkaAUdrPlynZar />} />
                <Route path="plynarenske_technologie" element={<PlynarenskeTechnologie />} />
                <Route path="softver_v_tepelnej_technike" element={<SoftverVTepTechnike />} />
                <Route path="technika_prostredia" element={<TechnikaProstredia />} />
                <Route path="odporucany_softver" element={<OdporucanySoftver />} />
                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </Col>
          
          <Col xs={12} md={3} className="bg-light p-3">
            <RightSidePage/>
          </Col>

        </Row>
      </Container>
    </BrowserRouter>

    
    </div>
  );
}

export default App;
